import { DashboardSpecMigrator } from '../dashboard-schema-migrator';
import { DashboardV0 } from '../../dashboard-spec-versions';

/**
 * Migrates dashboard spec to version 1
 */
export const V1Migrator: DashboardSpecMigrator<DashboardV0['spec']> = {
  version: '1',
  migrate: (spec) => {
    // Use spec_version instead
    if (spec.schemaVersion) {
      delete spec.schemaVersion;
    }

    return spec;
  },
};
